import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import BuyAssets from "./BuyAssets";
import { getFormData } from "../../../../helpers";

const OutstandingInvoices = ({
  outstandingInvoicesState,
  setOutstandingInvoicesState,
  localFormState,
  pageType,
  viewFormOptions,
}) => {
  const dispatch = useDispatch();
  const formOptions = useSelector(
    (state) => state.financeReducer?.addPaymentsFormData
  );

  const payTradeLiabilityData = useSelector(
    (state) => state?.financeReducer?.payTradeLiabilityData
  );
  const apLiabilityData = useSelector(
    (state) => state?.financeReducer?.apLiabilityData
  );

  const outstandingInvoices =
    localFormState?.purpose_id === 2 ? payTradeLiabilityData : apLiabilityData;
  function handleSelectAllItems() {
    // if it is not selected
    if (!outstandingInvoicesState?.isAllSelected)
      setOutstandingInvoicesState({
        ...outstandingInvoicesState,
        isAllSelected: true,
        selectedItemId: outstandingInvoices?.allTrans?.map((el) => el.id),
        totalAmount: outstandingInvoices?.allTrans?.reduce(
          (acc, curr) => acc + curr?.outstanding_amount,
          0
        ),
      });
    else {
      setOutstandingInvoicesState({
        ...outstandingInvoicesState,
        isAllSelected: false,
        selectedItemId: [],
        totalAmount: 0,
      });
    }
  }
  console.log(outstandingInvoices, "outstandingInvoices");

  function handleSingleItem(
    targetEl,
    outstandingInvoices,
    outstandingInvoicesState
  ) {
    const copiedSelectedItemId = [...outstandingInvoicesState?.selectedItemId];
    const targetIndex = copiedSelectedItemId?.findIndex(
      (itemId) => itemId == targetEl.id
    );
    const targetElAmount = targetEl?.outstanding_amount;

    // if target El is not checked
    if (targetIndex === -1) {
      const isAllSelected =
        outstandingInvoices?.length - 1 ===
        outstandingInvoicesState?.selectedItemId?.length;

      copiedSelectedItemId.push(targetEl?.id);
      setOutstandingInvoicesState({
        ...outstandingInvoicesState,
        isAllSelected: isAllSelected,
        selectedItemId: copiedSelectedItemId,
        totalAmount: outstandingInvoicesState?.totalAmount + targetElAmount,
      });
    } else {
      // if it is already checked
      copiedSelectedItemId?.splice(targetIndex, 1);
      setOutstandingInvoicesState({
        ...outstandingInvoicesState,
        isAllSelected: false,
        selectedItemId: copiedSelectedItemId,
        totalAmount: outstandingInvoicesState?.totalAmount - targetElAmount,
      });
    }
    // }
  }

  function getHtml(pageType) {
    const payments = viewFormOptions?.payments;
    if (pageType === "viewPayment") {
      return (
        <table className="checklist-table remove-space inventory_table">
          <thead>
            <tr>
              {outstandingInvoices?.isShowLinkedData && <th> Account </th>}
              <th>Date/Time</th>
              <th>Transaction ID</th>
              <th>Description</th>
              <th>Amount </th>
              <th>Paid Now </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{payments?.transaction_date}</td>
              <td>{payments?.transaction_ID}</td>
              <td>
                {viewFormOptions?.isShowLinkedData
                  ? payments?.merchant?.account_name
                  : payments?.memo}
              </td>
              <td>{payments?.amount}</td>
              <td>{payments?.amount}</td>
            </tr>
          </tbody>
        </table>
      );
    }
    if (pageType === "viewPayment") {
      return (
        <table className="checklist-table remove-space inventory_table">
          <thead>
            <tr>
              <th width="">
                <a class="checkbox avaiCheck">
                  <div class="input checkbox">
                    <input
                      onClick={() => handleSelectAllItems()}
                      type="checkbox"
                      value="1"
                      id="select_all"
                      checked={outstandingInvoicesState?.isAllSelected}
                    />
                    <label for="select_all"></label>
                  </div>
                </a>
              </th>
              {outstandingInvoices?.isShowLinkedData && <th> Account </th>}
              <th>Date/Time</th>
              <th>Transaction ID</th>
              <th>Description</th>
              <th>Amount </th>
              <th>Paid Now </th>
            </tr>
          </thead>
          <tbody>
            {outstandingInvoices?.allTrans?.map((el, idx) => (
              <tr>
                <td width="">
                  <a class="checkbox avaiCheck">
                    <div class="input checkbox">
                      <input
                        onClick={() =>
                          handleSingleItem(
                            el,
                            outstandingInvoices?.allTrans,
                            outstandingInvoicesState
                          )
                        }
                        type="checkbox"
                        value="1"
                        id={`select_all_${idx}`}
                        checked={
                          !!outstandingInvoicesState?.selectedItemId?.find(
                            (id) => id == el?.id
                          )
                        }
                      />
                      <label for={`select_all_${idx}`}></label>
                    </div>
                  </a>
                </td>
                {outstandingInvoices?.isShowLinkedData && (
                  <td>{el?.order_id}</td>
                )}
                <td>{el?.transaction_date}</td>
                <td>{el?.transaction_id}</td>
                <td>Order</td>
                <td>{el?.outstanding_amount}</td>
                <td>{el?.outstanding_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    return (
      <table className="checklist-table remove-space inventory_table">
        <thead>
          <tr>
            <th width="">
              <a class="checkbox avaiCheck">
                <div class="input checkbox">
                  <input
                    onClick={() => handleSelectAllItems()}
                    type="checkbox"
                    value="1"
                    id="select_all"
                    checked={outstandingInvoicesState?.isAllSelected}
                  />
                  <label for="select_all"></label>
                </div>
              </a>
            </th>
            {outstandingInvoices?.isShowLinkedData && <th> Account </th>}
            <th>Date/Time</th>
            <th>Transaction ID</th>
            <th>Description</th>
            <th>Amount </th>
            <th>Paid Now </th>
          </tr>
        </thead>
        <tbody>
          {outstandingInvoices?.allTrans?.map((el, idx) => (
            <tr>
              <td width="">
                <a class="checkbox avaiCheck">
                  <div class="input checkbox">
                    <input
                      onClick={() =>
                        handleSingleItem(
                          el,
                          outstandingInvoices?.allTrans,
                          outstandingInvoicesState
                        )
                      }
                      type="checkbox"
                      value="1"
                      id={`select_all_${idx}`}
                      checked={
                        !!outstandingInvoicesState?.selectedItemId?.find(
                          (id) => id == el?.id
                        )
                      }
                    />
                    <label for={`select_all_${idx}`}></label>
                  </div>
                </a>
              </td>
              {outstandingInvoices?.isShowLinkedData && <td>{el?.order_id}</td>}
              <td>{el?.transaction_date}</td>
              <td>{el?.transaction_id}</td>
              <td>Order</td>
              <td>{el?.outstanding_amount}</td>
              <td>{el?.outstanding_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
      <h4 className="event-alert w-100 mb-0">Outstanding Invoices</h4>
      <p>
        <strong> Select Invoices By Date Range </strong>
      </p>

      <div className="row col-12">
        <div class="col-sm-3">
          <div class="input-group">
            <DatePicker
              selected={outstandingInvoicesState.from_date}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => {
                setOutstandingInvoicesState({
                  ...outstandingInvoicesState,
                  from_date: date,
                });
              }}
            />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="input-group">
            <DatePicker
              selected={outstandingInvoicesState.to_date}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => {
                setOutstandingInvoicesState({
                  ...outstandingInvoicesState,
                  to_date: date,
                });
              }}
            />
          </div>
        </div>
        <div class="col-sm-3">
          <MultiSelect
            value={outstandingInvoicesState?.account_id}
            onChange={(arr) => {
              setOutstandingInvoicesState({
                ...outstandingInvoicesState,
                account_id: arr,
              });
            }}
            labelledBy="select"
            showCheckbox={true}
            // hasSelectAll={false}
            options={formOptions?.suppliers ?? []}
          />
        </div>

        <div class="btns col">
          <button
            onClick={() => {
              dispatch(
                actions?.getApLiabilityData({
                  payee_id: localFormState.payee_id,
                  from_date: moment(outstandingInvoicesState?.from_date).format(
                    "YYYY-MM-DD"
                  ),
                  to_date: moment(outstandingInvoicesState?.to_date).format(
                    "YYYY-MM-DD"
                  ),
                  account_id: outstandingInvoicesState?.account_id?.map(
                    (el) => el?.value
                  ),
                })
              );
            }}
            id=""
            type="Submit"
          >
            Apply
          </button>
        </div>
      </div>
      <div className="row col-12 mx-0">{getHtml(pageType)}</div>
    </div>
  );
};

export default OutstandingInvoices;
